import React, { useEffect, useState } from "react";
import { CiUser } from "react-icons/ci";
import axios from "axios";
import { TbCalendarTime } from "react-icons/tb";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Utils from "../../utils/utils";
import { useToast } from "../ToastContext";
import AssignmentGuide from "./AssignmentGuide";
import QuestionsList from "./QuestionsList";

const AssignmentViewStudent = ({ props }) => {
  const { item, index, editFormVisible, closeAssignmentView, user } = props;
  const token = Utils.getToken();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const [assignment, setAssignment] = useState(
    JSON.parse(JSON.stringify(item))
  );

  const [questions, setQuestions] = useState(assignment.questions);
  const [showQuestions, setShowQuestions] = useState(false);
  const [submission, setSubmission] = useState(null);
  const [submissions, setSubmissions] = useState([]); // answer arr

  const [updatedAns, setUpdatedAns] = useState({});
  const [answer, setAnswer] = useState("");
  const [result, setResult] = useState(submission?.result || false);

  const [newAnswer, setNewAnswer] = useState("");
  const [editingSubmission, setEditingSubmission] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const showToast = useToast();

  const [answers, setAnswers] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const [dueDate, setDueDate] = useState(null);
  const [isUnderTime, setIsTimeOver] = useState(false);

  const handleAnsInputChange = (id, value) => {
    setAnswers((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  // This function will be used when We will implement multiple submission

  // const HandleAssignmentSubmit = async (e) => {
  //   e.preventDefault();
  //   const formData = {};
  //   formData["assignmentId"] = assignment._id;
  //   formData["submittedAt"] = Utils.getCurrentTime();

  //   const isValid =
  //     !answer || answer.startsWith("http://") || answer.startsWith("https://");
  //   if (!isValid) {
  //     showToast(
  //       "Please enter valid URLs for submission.",
  //       "warning",
  //       true,
  //       7000
  //     );
  //     return;
  //   }

  //   formData["answer"] = answer;

  //   try {
  //     const res = await axios.post(
  //       `${SERVER_URL}/assignments/single-submission/submit`,
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     if (res.status === 201) {
  //       const response = res.data;
  //       const sub = response.submission;
  //       showToast(response.message, "success", true, 3000);
  //       setSubmission(sub);
  //       setSubmissions(sub.answers); // Array of Submissions
  //       setSubmission(sub.answer); // single Submission
  //     } else {
  //       showToast(res.statusText, "error", true, 4000);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     showToast("Something went wrong " + error.message, "error", true, 4000);
  //   }
  // };

  const FetchSubmission = async (assignmentId) => {
    try {
      const response = await axios.get(
        `${SERVER_URL}/assignments/submission/${assignmentId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const res = response.data.submission;
        if (res) {
          if (res) {
            setSubmission(res);
            if (res.answer) setNewAnswer((prev) => res.answer);
            if (res.result) setResult(res.result);
          }

          // const arr = res.answers;
          // const answersObject = Object.fromEntries(
          //   arr.map((item) => [item._id, item.answer])
          // );
          // setUpdatedAns((prev) => answersObject);
          // setSubmissions((prev) => res.answers);
        }
      } else {
        // showToast(response.statusText, "warning", true, 300);
      }
    } catch (error) {
      showToast(error.message, "error", true, 3000);
    }
  };

  const HandleAssignmentSubmit = async (e) => {
    e.preventDefault();
    const formData = {};
    formData["assignmentId"] = assignment._id;
    formData["submittedAt"] = Utils.getCurrentTime();
    const singleSubmission = assignment.submissionType;
    formData["singleSubmission"] = singleSubmission;

    const isValid =
      answer && (answer.startsWith("http://") || answer.startsWith("https://"));
    if (!isValid) {
      showToast(
        "Please enter valid URLs for submission.",
        "warning",
        true,
        7000
      );
      return;
    }

    formData["answer"] = answer;

    // Below will implement on multiple submissins
    // if (singleSubmission) {
    //   const isValid =
    //     answer || answer.startsWith("http://") || answer.startsWith("https://");
    //   if (!isValid) {
    //     showToast(
    //       "Please enter valid URLs for submission.",
    //       "warning",
    //       true,
    //       7000
    //     );
    //     return;
    //   }
    //   formData["answer"] = answer;
    // } else {
    //   const isValid =
    //     Object.entries(answers).some(([questionId, url]) => url) &&
    //     Object.entries(answers).every(
    //       ([questionId, url]) =>
    //         !url || url.startsWith("http://") || url.startsWith("https://")
    //     );

    //   if (!isValid) {
    //     showToast(
    //       "Please enter valid URLs for all non-empty answers.",
    //       "warning",
    //       true,
    //       5000
    //     );
    //     return;
    //   }
    //   const ansArr = questions.map((ques) => ({
    //     questionId: ques._id,
    //     answer: answers[ques._id] || "",
    //   }));
    //   formData["answers"] = ansArr;
    // }

    try {
      const res = await axios.post(
        `${SERVER_URL}/assignments/submit`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.status === 201) {
        const response = res.data;
        const sub = response.submission;
        showToast(response.message, "success", true, 3000);
        setSubmission(sub);
        if (sub?.answers?.length) {
          setSubmissions(sub.answers);
        }
        if (sub?.answer) setAnswer(sub.answer); // single Submission
        setNewAnswer(sub.answer);
      } else {
        showToast(res.statusText, "error", true, 4000);
      }
    } catch (error) {
      if (error.status === 409) {
        const data = error.response;
        showToast(data.message, "warning", true, 4000);
      } else if (error.status === 422) {
        const msg = error.response.message || "Something went wrong";
        showToast(msg, "warning", true, 4000);
      } else
        showToast("Something went wrong " + error.message, "error", true, 4000);
    }
  };

  const HandleReSubmisssion = async (e) => {
    e.preventDefault();

    // Might use later when allow the multiple submission
    // const updatedAnsArr = submissions.map((item) => ({
    //   _id: item._id,
    //   marksObtained: item.marksObtained,
    //   questionId: item.questionId,
    //   answer: updatedAns[item._id],
    // }));

    // const isValid =
    //   Object.entries(updatedAns).some(([_id, answer]) => answer) &&
    //   Object.entries(updatedAns).every(
    //     ([_id, answer]) =>
    //       !answer ||
    //       answer.startsWith("http://") ||
    //       answer.startsWith("https://")
    //   );

    // if (!isValid) {
    //   showToast(
    //     "Please enter valid URLs for all non-empty answers.",
    //     "warning",
    //     true,
    //     7000
    //   );
    //   return;
    // }

    // const isAnyAnswerUpdated = updatedAnsArr.some((item) => {
    //   const prev = submissions.find((old) => old._id === item._id);
    //   return prev && item.answer !== prev.answer;
    // });
    // if (!isAnyAnswerUpdated) {
    //   showToast("No new changes found in submissions!", "warning", true, 4000);
    //   return;
    // }

    const singleSubmission = assignment.submissionType;

    const dueTime = new Date(dueDate);
    const currentTime = new Date(new Date().toUTCString());
    const isSubmissionAllowed = submission?.allowResubmission || false;
    if (currentTime > dueTime && !isSubmissionAllowed) {
      showToast("Assignment time is over", "warning", true, 3000);
      return;
    }

    if (answer && newAnswer && answer === newAnswer) {
      showToast("No new changes found", "warning", true, 3000);
      return;
    }

    const isValid =
      newAnswer &&
      (newAnswer.startsWith("http://") || newAnswer.startsWith("https://"));

    if (!isValid) {
      showToast("Please input a valid url!", "warning", true, 3000);
      return;
    }

    const formData = {};
    formData["assignmentId"] = assignment._id;
    formData["submittedAt"] = Utils.getCurrentTime();
    // formData["answers"] = updatedAnsArr;
    formData["answer"] = newAnswer;
    formData["singleSubmission"] = singleSubmission;

    if (submission?.allowResubmission) formData["allowResubmission"] = false;
    try {
      const res = await axios.put(
        `${SERVER_URL}/assignments/resubmission/${submission._id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.status === 200) {
        const response = res.data;
        const sub = response.submission;
        showToast(response.message, "success", true, 3000);
        setSubmission(sub);
        if (sub.answer) setAnswer(sub.answer);
        setEditingSubmission(false);

        // Below will be implemented on the Multiple submission
        // const returnArr = sub.answers;
        // const answerWithQuestion = returnArr.map((item) => {
        //   const questionData = submissions.find(
        //     (q) => q.questionId === item.questionId
        //   );
        //   return { ...item, question: questionData.question };
        // });
        // setSubmissions(answerWithQuestion);
      } else {
        showToast(res.statusText, "error", true, 4000);
      }
    } catch (error) {
      showToast("Something went wrong " + error.message, "error", true, 4000);
    }
  };

  useEffect(() => {
    if (dueDate) {
      const dueTime = new Date(dueDate);
      const currentTime = new Date(new Date().toUTCString());
      const isSubmissionAllowed = submission?.allowResubmission || false;
      const timeOver = currentTime <= dueTime || isSubmissionAllowed;
      setIsTimeOver(timeOver);
    }
    if (submission?.answer) {
      setAnswer(submission.answer);
    }
  }, [dueDate, submission?.allowResubmission]);

  useEffect(() => {
    const dueDateForBatch = assignment.dueDates?.[user.batch];
    if (dueDateForBatch) {
      setDueDate(dueDateForBatch);
    }
  }, [user]);

  useEffect(() => {
    FetchSubmission(assignment._id);
  }, []);

  const ResultBtnStyle = {
    Cleared: "bg-green-100 text-green-800 hover:bg-green-200",
    "Partially Cleared": "bg-yellow-100 text-yellow-800 hover:bg-yellow-200",
    "Not Cleared": "bg-red-100 text-red-800 hover:bg-red-200",
  };

  return (
    <div
      bkl="AssignmentViewStudent"
      className={`fixed inset-y-0 rounded-lg right-0 z-50  w-[90%] md:w-[90%] sm:w-[90%] xs:w-[90%] shadow-lg transform ${
        editFormVisible ? "animate-slideInRight" : "animate-slideOutRight"
      }`}
    >
      <div
        className="min-h-full h-full overflow-x-hidden overflow-y-auto bg-white p-4 rounded-l-lg"
        style={{
          WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE and Edge
        }}
      >
        <AssignmentGuide props={{ showGuide, setShowGuide }} />
        <div className="p-6 space-y-4 shadow rounded-lg bg-white mb-4">
          <div className="p-2 bg-gray-50 flex justify-between flex-col sm:flex-row sm:items-start sm:justify-between ">
            <div className="text-2xl font-semibold text-gray-700 order-2 flex-1 space-y-4 sm:order-1 ">
              {assignment.title}
            </div>
            <div className="flex flex-wrap w-fit justify-end gap-2 order-1 space-y-4 sm:order-2 xs:justify-start ">
              {submission?.allowResubmission && (
                <button
                  disabled
                  className="bg-green-100 text-green-600 font-semibold rounded-md py-2 px-4 xs:py-1 xs:px-2 text-sm shadow hover:bg-green-200 hover:text-green-700 transition duration-200 ease-in-out"
                >
                  Resubmission Allowed
                </button>
              )}
              {!isUnderTime && (
                <button
                  disabled
                  className="bg-red-200 text-red-600 cursor-not-allowed font-semibold rounded-md py-2 px-4 xs:py-1 xs:px-2 text-sm shadow hover:bg-red-300 hover:text-red-800 transition duration-200 ease-in-out"
                >
                  Submission time ended!
                </button>
              )}
            </div>
          </div>

          <p className="text-gray-600 text-md">
            <span className="font-medium">Description: </span>
            {assignment.description}
          </p>

          <div className="flex flex-wrap gap-6 xs:gap-2 items-start">
            {/* Instructor Details */}
            <div className="flex items-center gap-2">
              <div
                className={`h-8 w-8 text-sm rounded-full flex items-center justify-center overflow-hidden ${
                  assignment.instructorName
                    ? Utils.getRandomBgColor() + " text-white"
                    : ""
                }`}
              >
                {assignment.instructorName ? (
                  Utils.getUserAvatar(assignment.instructorName)
                ) : (
                  <CiUser className="w-5 h-5" />
                )}
              </div>
              <span className="font-normal text-md text-[#544D4F]">
                {assignment.instructorName || "Instructor Name"}
              </span>
            </div>

            {/* Due Date */}
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 rounded-full flex justify-center items-center overflow-hidden bg-gray-100">
                <TbCalendarTime className="w-5 h-5 text-gray-600" />
              </div>
              <p className="font-normal text-md text-gray-700">
                <span>Concludes on </span>
                <span className="text-red-500">
                  {dueDate ? Utils.formatDateTime(dueDate) : "N/A"}
                </span>
              </p>
            </div>
          </div>

          {/* Remarks Section */}
          {assignment.remarks && (
            <p className="text-gray-500 text-md italic">
              <span className="font-medium">Remarks: </span>
              {assignment.remarks}
            </p>
          )}

          <div className="">
            <button
              onClick={() => setShowQuestions(!showQuestions)}
              className="inline-flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
            >
              Questions
              {showQuestions ? (
                <FaChevronUp className="mt-1" />
              ) : (
                <FaChevronDown className="mt-1" />
              )}
            </button>
          </div>

          {assignment?.questions && showQuestions && (
            <QuestionsList questions={assignment.questions} />
          )}
        </div>

        <div className="p-6 space-y-6 bg-gray-50 h-fit rounded-md">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">
            Assignment Submission
          </h1>

          <div className="p-6 border rounded-lg shadow-md bg-white space-y-4">
            <div className="flex justify-between items-center xs:flex-wrap xs:flex-row-reverse">
              <span className="text-sm font-semibold text-red-500 italic">
                **Please enter a single url for the assignment.**
              </span>
              <span className="text-sm font-semibold text-blue-600">
                Max Marks :
                {assignment.maxMarks >= 0 ? " " + assignment.maxMarks : " N/A"}
              </span>
            </div>

            {submission?.answer ? (
              <div>
                <div>
                  <label
                    htmlFor={"submission"}
                    className="block text-sm font-semibold text-gray-600 mb-2"
                  >
                    Submission URL:
                  </label>
                  <input
                    type="url"
                    name={"submission"}
                    value={newAnswer}
                    disabled={!editingSubmission}
                    onChange={(e) => {
                      const val = e.target.value || "";
                      setNewAnswer((prev) => val);
                    }}
                    className={`w-full px-4 py-2 text-sm text-gray-700 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none 
                    ${
                      answer
                        ? "border-green-600"
                        : !isUnderTime
                        ? "border-red-600"
                        : "border-gray-300"
                    }`}
                    placeholder="Enter submission URL"
                  />
                </div>
                <div className="flex justify-end">
                  {editingSubmission ? (
                    <div className="flex gap-2">
                      <button
                        onClick={() => setEditingSubmission(false)}
                        className="mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm bg-white text-orange-600 border border-orange-600 uppercase 
                  rounded-lg shadow hover:text-orange-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={HandleReSubmisssion}
                        className="mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm bg-white text-green-600 border border-green-600 uppercase 
                  rounded-lg shadow hover:text-green-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
                      >
                        Resubmit
                      </button>
                    </div>
                  ) : (
                    <>
                      {isUnderTime ? (
                        <button
                          onClick={() => setEditingSubmission(true)}
                          className="mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm  text-blue-600 border border-blue-600 uppercase 
                  rounded-lg shadow hover:text-blue-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
                        >
                          Edit Submissions
                        </button>
                      ) : (
                        <button className="mt-6 bg-red-200 text-red-600 cursor-not-allowed font-semibold rounded-md py-2 px-4 xs:py-1 xs:px-2 text-sm shadow hover:bg-red-300 hover:text-red-800  transition duration-200 ease-in-out">
                          Submission time ended!
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <div>
                  <label
                    htmlFor={"submission"}
                    className="block text-sm font-semibold text-gray-600 mb-2"
                  >
                    Submission URL:
                  </label>
                  <input
                    type="url"
                    name={"submission"}
                    disabled={!isUnderTime}
                    value={answer}
                    onChange={(e) => {
                      const val = e.target.value || "";
                      setAnswer((prev) => val);
                    }}
                    className={`w-full px-4 py-3 text-sm text-gray-700 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none 
                        ${
                          answer
                            ? "border-green-600"
                            : !isUnderTime
                            ? "border-red-600"
                            : "border-gray-300"
                        }`}
                    placeholder="Enter submission URL"
                  />
                </div>
                <div className="flex justify-end pb-1">
                  {isUnderTime ? (
                    <button
                      disabled={!answer}
                      onClick={HandleAssignmentSubmit}
                      className={`mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm uppercase rounded-lg shadow 
                        ${
                          !answer
                            ? "cursor-not-allowed bg-gray-200"
                            : "text-pink-800 border border-pink-800  hover:pink-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
                        } `}
                    >
                      Submit
                    </button>
                  ) : (
                    <button className="mt-6 bg-red-200 text-red-600 cursor-not-allowed font-semibold rounded-md py-2 px-4 xs:py-1 xs:px-2 text-sm shadow hover:bg-red-300 hover:text-red-800  transition duration-200 ease-in-out">
                      Submission time ended!
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>

          {submission?.assessed && (
            <div className="p-6 border rounded-lg shadow-md bg-white space-y-4">
              <div className="flex justify-between items-center">
                <div className="flex justify-center">
                  {result === "Cleared" && (
                    <button
                      className={`py-2 px-4 xs:py-1 xs:px-2 text-sm uppercase rounded-lg tracking-[0.5px] transition duration-200 border border-green-500 ${ResultBtnStyle.Cleared}`}
                    >
                      Cleared
                    </button>
                  )}
                  {result === "Partially Cleared" && (
                    <button
                      className={`py-2 px-4 xs:py-1 xs:px-2 text-sm uppercase rounded-lg tracking-[0.5px] transition duration-200 border border-yellow-500 ${ResultBtnStyle["Partially Cleared"]}`}
                    >
                      Partially Cleared
                    </button>
                  )}
                  {result === "Not Cleared" && (
                    <button
                      className={`py-2 px-4 xs:py-1 xs:px-2 text-sm uppercase rounded-lg tracking-[0.5px] transition duration-200 border border-red-500 ${ResultBtnStyle["Not Cleared"]}`}
                    >
                      Not Cleared
                    </button>
                  )}
                </div>

                <span className="text-sm font-semibold text-blue-600">
                  Marks :
                  {submission.totalMarksObtained >= 0
                    ? " " + submission.totalMarksObtained
                    : " N/A"}
                </span>
              </div>
              <p className="text-gray-600 text-md">
                <span className="font-medium">Feedback : </span>
                {submission.feedback ? submission.feedback : "-"}
              </p>
            </div>
          )}
        </div>

        {/* 
        {(submission && submissions.length) > 0 ? (
          <div className="p-6 space-y-6 bg-gray-100 h-fit rounded-md">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              Assignment Submission
            </h1>

            {submissions.map((ans, i) => (
              <div
                key={ans._id}
                className="p-6 border rounded-lg shadow-md bg-white space-y-4"
              >
                <div className="flex justify-between items-center">
                  <span className="text-sm font-semibold text-gray-500">
                    Sr. No: {i + 1}
                  </span>
                  <span className="text-sm font-semibold text-blue-600">
                    Max Marks: {ans.maxMarks >= 0 ? ans.maxMarks : "N/A"}
                  </span>
                </div>

                <div className="space-y-2">
                  <p className="text-lg font-medium text-gray-700">Question:</p>
                  <p className="text-base text-gray-600">
                    {ans.question?.question || questions[ans.questionId]}
                  </p>
                </div>

                <div>
                  <label
                    htmlFor={"submission" + ans._id}
                    className="block text-sm font-semibold text-gray-600 mb-2"
                  >
                    Submission URL:
                  </label>
                  <input
                    type="url"
                    id={"submission" + ans._id}
                    name={"submission" + ans._id}
                    value={editingSubmission ? updatedAns[ans._id] : ans.answer}
                    disabled={!editingSubmission}
                    onChange={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      const val = e.target.value ? e.target.value : "";
                      setUpdatedAns((prev) => ({
                        ...prev,
                        [ans._id]: val,
                      }));
                    }}
                    className={`w-full px-4 py-3 text-sm text-gray-700 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none 
                      ${
                        !editingSubmission &&
                        (ans.answer ? "border-green-600" : "border-red-600")
                      }`}
                    placeholder="Enter submission URL"
                  />
                </div>
              </div>
            ))}

        
            <div className="flex justify-end">
              {editingSubmission ? (
                <div className="flex gap-2">
                  <button
                    onClick={() => setEditingSubmission(false)}
                    className="mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm bg-white text-orange-600 border border-orange-600 uppercase 
                  rounded-lg shadow hover:text-orange-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={HandleReSubmisssion}
                    className="mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm bg-white text-green-600 border border-green-600 uppercase 
                  rounded-lg shadow hover:text-green-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
                  >
                    Resubmit
                  </button>
                </div>
              ) : (
                <>
                  {isUnderTime ? (
                    <button
                      onClick={() => setEditingSubmission(true)}
                      className="mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm  text-blue-600 border border-blue-600 uppercase 
                  rounded-lg shadow hover:text-blue-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
                    >
                      Edit Submissions
                    </button>
                  ) : (
                    <button className="bg-red-200 text-red-600 cursor-not-allowed font-semibold rounded-md py-2 px-4 xs:py-1 xs:px-2 text-sm shadow hover:bg-red-300 hover:text-red-800  transition duration-200 ease-in-out">
                      Submission time ended!
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        ) : (
          <div className="p-6 space-y-6 shadow-lg min-h-fit rounded-lg">
            <table className="table">
              <thead>
                <tr className="bg-gray-50 p-4 text-sm">
                  <th className="w-[5%] text-center ">Sr. No</th>
                  <th className="w-[35%] text-center ">Questions</th>
                  <th className="w-[10%] text-center">Maximum Marks</th>
                  <th className="w-[35%] text-center">Submission URL</th>
                </tr>
              </thead>

              <tbody>
                {questions.map((question, i) => (
                  <tr key={question._id} className="">
                    <td className="text-center font-semibold">
                      <span>{i + 1}.</span>
                    </td>
                    <td className="" key={question._id + "Name"}>
                      <div className="flex items-center gap-3">
                        {question.question}
                      </div>
                    </td>

                    <td className="text-center font-semibold">
                      <span>
                        {question.maxMarks && question.maxMarks >= 0
                          ? question.maxMarks
                          : "N/A"}
                      </span>
                    </td>

                    <td className="">
                      <input
                        type="url"
                        disabled={!isUnderTime}
                        name={"submission" + question._id}
                        value={answers[question._id] || ""}
                        onChange={(e) =>
                          handleAnsInputChange(question._id, e.target.value)
                        }
                        className="w-full text-left px-4 py-3 rounded-lg bg-gray-50 border
                         focus:border-pink-700 focus:bg-white focus:outline-none"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="flex justify-end pb-1">
              {isUnderTime ? (
                <button
                  onClick={HandleAssignmentSubmit}
                  className="mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm bg-white text-pink-800 border border-pink-800 uppercase 
                  rounded-lg shadow hover:pink-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
                >
                  Submit
                </button>
              ) : (
                <button className="bg-red-200 text-red-600 cursor-not-allowed font-semibold rounded-md py-2 px-4 xs:py-1 xs:px-2 text-sm shadow hover:bg-red-300 hover:text-red-800  transition duration-200 ease-in-out">
                  Submission time ended!
                </button>
              )}
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default AssignmentViewStudent;
